<template>
    <div class="alert fade show" :class="[_variant, { 'alert-dismissible': dismissible }, { 'alert-outline': outline }]"
        role="alert" :id="id">
        <d-row :class="classname" class="d-flex align-items-center">
            <d-col cols="auto" class="pe-0" v-if="!hideicon">
                <d-svg v-if="icon" :src="icon" width="1.5em" height="1.5em"></d-svg>
                <div v-else-if="alerticon" v-html="alerticon" style="width:1.5em;height: 1.5em;"></div>
            </d-col>
            <d-col class="my-auto">
                <slot></slot>
            </d-col>
            <d-col cols="auto">
                <span v-if="show_auto_dissmiss && !hidecounter && autodissmissmode == 'counter'">{{ timeleft }}</span>
                <d-button v-if="dismissible" :variant="_the_variant" class="btn-close" @click="Close"></d-button>
            </d-col>
            <d-col cols="12" v-if="show_auto_dissmiss && autodissmissmode == 'fuse'">
                <div class="fuse" :style="fuse_style"></div>
            </d-col>
        </d-row>
    </div>
</template>

<script setup>

import { ref, computed, defineProps, defineEmits, toRefs, onMounted } from 'vue'
import { Alert } from 'bootstrap'; // Import Bootstrap's JavaScript
import icons from "@/dod/enums/dicons";

const emit = defineEmits(['dissmissed'])

// PROPS
const props = defineProps({
    variant: { type: String, default: "primary" },
    animation: String,
    icon: String,
    hideicon: { type: Boolean, default: false },
    centered: Boolean,
    dismissible: Boolean,
    autodissmiss: { type: Number, default: -1 },
    autodissmissmode: { type: String, default: "fuse" },
    hidecounter: { type: Boolean, default: false },
    outline: Boolean
})
const { variant, icon, autodissmiss } = toRefs(props);

const timeleft = ref(autodissmiss.value);
const id = (Math.random() * 100000) + '_alert';

// computed
const _the_variant = computed(() => (props.outline ? "outline-": "") + (variant.value ?? "primary").replace("outline-", ""))

const _variant = computed(() => "alert-" + (_the_variant.value ?? "primary"))
const alerticon = computed(() => {
    var v = _the_variant.value;
    switch (v) {
        case "info":
        case "primary":
        case "secondary":
            return icons.alert_icons.info;
        case "warning":
            return icons.alert_icons.warning;
        case "light":
            return icons.alert_icons.light;
        case "dark":
            return icons.alert_icons.dark;
        case "danger":
            return icons.alert_icons.danger;
        case "success":
            return icons.alert_icons.success;
        default:
            return false;
    }
})

const show_auto_dissmiss = computed(() => timeleft.value > 0 && timeleft.value < 60)
const fuse_style = computed(() => {
    var width = 0;
    if (timeleft.value > 0)
        width = (timeleft.value / autodissmiss.value) * 100;
    width = "width:" + (width) + "%;"
    var bg = 'background-color:var(--bs-alert-border-color);';
    return width + bg;
})
const classname = computed(() => "text-start")

function Tick() {
    setTimeout(() => { timeleft.value--; if (timeleft.value <= 0) Close(); else Tick() }, 1000)
}

function Close() {
    const alert = Alert.getOrCreateInstance('#' + id);
    if(!alert || Object.keys(alert).length <= 0)
        return;
    alert.close()
    emit("dissmissed");
}

onMounted(() => {
    if (autodissmiss.value > 0) {
        Tick();
    }
})


</script>

<style lang="scss" scoped></style>
